import { useCart } from '../../components/Context/Cart';
import { Link } from 'react-router-dom';

export default function Cart() {
  const { cartItems, increaseQuantity, decreaseQuantity, removeFromCart, totalPrice } = useCart();

  const shippingCost = 30;
  const total = totalPrice + shippingCost;

  return (
    <div className="container my-5 d-flex justify-content-between flex-wrap">
      
      {/* قائمة المنتجات */}
      <div className="col-md-8 border rounded p-4 bg-light">
        <h4 className="mb-3">Item List</h4>
        {cartItems.length === 0 ? (
          <p className="text-center text-muted">سلتك فارغة حالياً</p>
        ) : (
          cartItems.map(item => (
            <div key={item.id} className="d-flex align-items-center border-top py-3">
              <img src={item.image} alt={item.title} style={{ width: '80px', height: '80px', objectFit: 'contain' }} />
              <div className="ms-3 flex-grow-1">
                <h6 className="mb-1">{item.title}</h6>
                <div className="d-flex align-items-center mb-2">
                  <button className="btn btn-sm btn-outline-dark me-2" onClick={() => decreaseQuantity(item.id)}>-</button>
                  <span>{item.quantity}</span>
                  <button className="btn btn-sm btn-outline-dark ms-2" onClick={() => increaseQuantity(item.id)}>+</button>
                </div>
                <p className="fw-bold">{item.quantity} x ${item.price.toFixed(2)}</p>

                {/* زرار حذف المنتج */}
                <button 
                  className="btn btn-sm btn-danger"
                  onClick={() => removeFromCart(item.id)}>
                  Remove
                </button>
              </div>
            </div>
          ))
        )}
      </div>

      {/* ملخص الطلب */}
      <div className="col-md-3 border rounded p-4 ms-md-3 mt-4 mt-md-0 bg-light">
        <h4 className="mb-3">Order Summary</h4>

        {/* عدد المنتجات والسعر الكلي أو صفر لو السلة فاضية */}
        <div className="d-flex justify-content-between mb-2">
          <span>Products ({cartItems.length})</span>
          <span>${cartItems.length === 0 ? "0.00" : totalPrice.toFixed(2)}</span>
        </div>

        {/* تكلفة الشحن ثابتة أو صفر لو السلة فاضية */}
        <div className="d-flex justify-content-between mb-2">
          <span>Shipping</span>
          <span>${cartItems.length === 0 ? "0.00" : shippingCost}</span>
        </div>

        {/* السعر النهائي مع الشحن أو صفر لو مافيش منتجات */}
        <div className="d-flex justify-content-between fw-bold border-top pt-2">
          <span>Total amount</span>
          <span>${cartItems.length === 0 ? "0.00" : total.toFixed(2)}</span>
        </div>
          <Link to="/checkout">
          <button className="btn btn-dark w-100 mt-4" disabled={cartItems.length === 0}>Go to checkout</button>
          </Link>
        
      </div>

    </div>
  );
}
